import React, { useEffect, useState } from "react";

const Marker = ({ infoWindow, ...props }: any) => {
  const [marker, setMarker] = useState<google.maps.Marker>();
  const [showInfoWindow, setShowInfoWindow] = useState<boolean>(false);

  useEffect(() => {
    if (!marker) {
      setMarker(new google.maps.Marker());
    }

    return () => {
      if (marker) {
        marker.setMap(null);
      }
    };
  }, [marker]);

  useEffect(() => {
    if (marker) {
      const contentString = `<div style="color: #2a2f39">` + infoWindow + `</div>`;

      const win = new google.maps.InfoWindow({
        content: contentString,
      });

      if (props.anchor) {
        props["icon"]["anchor"] = new google.maps.Point(
          props.anchor ? props.anchor[0] : 0,
          props.anchor ? props.anchor[1] : 0
        );
      }
      props["icon"]["scaledSize"] = new google.maps.Size(
        props.dimension ? props.dimension[0] : 30,
        props.dimension ? props.dimension[1] : 30
      );
      marker.setOptions(props);

      // mount info window only once
      if (!showInfoWindow) {
        marker.addListener("click", () => {
          win.open({
            // @ts-ignore
            anchor: marker,
            shouldFocus: false,
          });
        });
        setShowInfoWindow(true);
      }
    }
  }, [infoWindow, marker, props, showInfoWindow]);

  return null;
};

export default Marker;

// TODO decouple info window, style info markers when designs are ready
